export const MODULE_NAME: string = 'fdxModal';
